/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} WebsiteInputs */

const en_website = /** @type {(inputs: WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website`)
};

const de_website = /** @type {(inputs: WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webseite`)
};

/**
* | output |
* | --- |
* | "Website" |
*
* @param {WebsiteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const website = /** @type {((inputs?: WebsiteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<WebsiteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_website(inputs)
	return en_website(inputs)
});